import { createFileRoute } from "@tanstack/react-router";
import { auth } from "@/content";
import { TokenLinkPage } from "@/components/auth/token-link";

/** Activating a new account from an invite. Shared screen; see `TokenLinkPage`. */
export const Route = createFileRoute("/_auth/_anonymous/accept-invite")({
  component: AcceptInvitePage,
});

function AcceptInvitePage() {
  return (
    <TokenLinkPage
      purpose="invite"
      title={auth.inviteTitle}
      lead={auth.inviteLead}
      submitLabel={auth.inviteSubmit}
      expiredTitle={auth.linkExpiredTitle}
      expiredLead={auth.inviteExpiredLead}
      usedLead={auth.inviteUsedLead}
    />
  );
}
